module.exports = __webpack_public_path__ + "static/servicios-coles-icon-3f9dd745c541b219a4d7ec9f5645017e.png";